import axios from "axios";
import { Base_URL } from "../url";

// Fetch Cost Center options for dropdown
export const fetchCostCenters = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CostCenterMaster/GetAllCostCenters`);
    return response.data.map(item => ({
      code: item.costCenterCode,
      name: item.costCenterName
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching cost centers!";
  }
};

// Save Cost Center Group
export const saveCostCenterGroup = async (groupData, userId) => {
  try {
    const response = await axios.post(
      `${Base_URL}/CostCenterGroup/CostCenterGroup?UserName=${userId}`, 
      groupData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving cost center group!";
  }
};